export type ClientOrderId = `0x${string}`

export function createClientOrderId(): ClientOrderId {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  return `0x${Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("")}`
}
